module.exports = __webpack_public_path__ + "img/Security.11e16ac5.jpg";